// src/stone/icons/LoyaltyHeart2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LoyaltyHeart2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M18.333 2.333a1 1 0 0 1 .708.293l11.666 11.667A1 1 0 0 1 31 15v3.333a1 1 0 1 1-2 0v-2.919L18.333 4.748 7.667 15.414v21.92H20a1 1 0 1 1 0 2H6.667a1 1 0 0 1-1-1V15a1 1 0 0 1 .293-.707L17.626 2.626a1 1 0 0 1 .707-.293" }),
      /* @__PURE__ */ jsx("path", { d: "M18.333 14.333a2.333 2.333 0 1 0 0 4.667 2.333 2.333 0 0 0 0-4.667M14 16.667a4.333 4.333 0 1 1 8.667 0 4.333 4.333 0 0 1-8.667 0M30 25.114c1.784-1.53 4.545-1.512 6.304.226a4.56 4.56 0 0 1 0 6.503L30 38.073l-6.304-6.23a4.56 4.56 0 0 1 0-6.503c1.757-1.736 4.519-1.757 6.304-.226m4.899 1.649c-1.179-1.164-3.148-.97-4.069.401L30 28.4l-.83-1.234c-.922-1.373-2.891-1.565-4.069-.402m9.798 0a2.56 2.56 0 0 1 0 3.657L30 35.26l-4.899-4.84a2.56 2.56 0 0 1 0-3.657" })
    ]
  }
);
var LoyaltyHeart2X_default = LoyaltyHeart2X;

export {
  LoyaltyHeart2X_default
};
